<template>
  <div>
    <VueDraggableNext
      class="element"
      v-for="variable in model.vars.choices"
      :key="variable.value"
      draggable="true"
      @dragstart="onDragStart(variable, $event)"
    >
      <span class="badge bg-success btnStyle me-2 mb-2">%{{ variable.value }}%</span>
    </VueDraggableNext>
  </div>
</template>

<script>
import { VueDraggableNext } from "vue-draggable-next";

export default {
  name: "TemplateVariableTypeComponent",
  components: { VueDraggableNext },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onDragStart(variable, event) {
      event.dataTransfer.setData("text/plain", `%${variable.value}%`);
    },
  },
};
</script>

<style scoped lang="scss">
.element {
  display: inline;
}
</style>
